import { NgOptimizedImage } from "@angular/common";
import { Component, input } from "@angular/core";
import { RouterModule } from "@angular/router";

export type TestimonialConfig = {
  quote: string;
  imgUrl: string;
  altDescription: string;
  namePosition: string;
};

@Component({
  selector: "app-testimonial-card",
  templateUrl: "./testimonial-card.component.html",
  styleUrls: ["./testimonial-card.component.scss"],
  imports: [RouterModule, NgOptimizedImage],
})
export class TestimonialCardComponent {
  public readonly testimonialConfig = input.required<TestimonialConfig>();
}
